<template>
  <div class="service-shipping">
    <h2>商品寄送</h2>
    <p>金牌王國將會在確認收到貨款後，商品以郵局包裹方式寄出，出貨時間:扣除國定例假日，7-10個工作天。金牌王國負擔全物流費用。</p>
    <h2>自行取貨</h2>
    <!-- <p>歡迎您至營業處取貨。請於完成訂單程序中，選擇來電取貨，系統會在貨品送達營業處後發出訊息通知您，在營業時間內，來店取貨。</p> -->
    <p>歡迎您至營業處取貨。請來電預約，在營業時間內，來店取貨。</p>
    <div class="mobile_backNav" v-if="isMobileButtonShow">
      <i class="fa fa-angle-left"></i>
      <router-link to="/gold/service_mobile">返回說明與服務</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceShipping",
  data() {
    return {
      isMobileButtonShow: false
    };
  },
  created() {
    let device = this.$store.getters.getDeviceSize;
    if (device < 585) {
      this.isMobileButtonShow = true;
    }
  }
};
</script>

<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.service-shipping {
  width: 66.73%;
  text-align: left;
  min-height: calc(100vh - 377px);
  h2 {
    font-size: 35px;
    font-weight: 600;
    letter-spacing: 2px;
    color: $primaryDeepColor;
    margin-top: 0;
  }
  p {
    font-size: 17px;
    color: $secondaryDeepColor1;
    line-height: 30px;
  }
}
.mobile_backNav {
  margin-top: 24px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    color: $primaryDeepColor;
    margin-right: 10px;
  }
  a {
    color: $primaryDeepColor;
  }
}
</style>
